// extracted by mini-css-extract-plugin
export default {"wrapper":"src-constrains-SortableTree-css-module__wrapper--j7O4n"};